import { Box, Typography } from "@mui/material";
import Fade from "@mui/material/Fade";

export default function PageHeader({ title }) {
  return (
    <Fade in timeout={400}>
      <Box sx={{ mb: 3 }}>
        <Typography variant="h5" fontWeight={600}>
          {title}
        </Typography>
      </Box>
    </Fade>
  );
}